module.exports = __webpack_public_path__ + "./img/odd.62d89ecdc030e8170d086975845e5b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/odd.png
// module id = ./src/containers/Briefcase/entry/icons/odd.png
// module chunks = 0